module.exports = __webpack_public_path__ + "img/PS1_installed.f60fb3ed.webp";